// Angular Modules
import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  APP_INITIALIZER,
  ErrorHandler,
  LOCALE_ID,
  NgModule,
} from '@angular/core';
import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';

// Locale datas
import localeDa from '@angular/common/locales/da';
import localeDaExtra from '@angular/common/locales/extra/da';
import localeHuExtra from '@angular/common/locales/extra/hu';
import localePlExtra from '@angular/common/locales/extra/pl';
import localeHu from '@angular/common/locales/hu';
import localePl from '@angular/common/locales/pl';

// Extrenal Node Modules
import { AgmCoreModule } from '@agm/core';
import { Angulartics2Module } from 'angulartics2';

// Core Modules, Services
import { CoreModule } from '@core/core.module';
import {
  appInitializerFactory,
  AppInitializerService,
} from '@core/services/app-initializer/app-initializer.service';
import { GlobalErrorHandler } from '@core/services/error/global-error-handler.service';
import { AppHttpInterceptor } from '@core/services/http/http-interceptor';
import { environment } from '@env';
import {
  HTTP_MODULE_CONFIG,
  SsrModule,
  TranslateService,
} from '@interticket/core';
import { SharedModule } from '@shared/shared.module';
import { AppRouterModule } from 'common';
import { AppRouterComponent } from './app.router.component';
import { AppRoutes } from './app.routes';

// App Core Components
import { ErrorPageRouterComponent } from '@modules/error-page/error-page.router';

registerLocaleData(localeHu, 'hu', localeHuExtra);
registerLocaleData(localeDa, 'da', localeDaExtra);
registerLocaleData(localePl, 'pl', localePlExtra);

@NgModule({
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    HammerModule,
    SsrModule.forRoot(),
    BrowserAnimationsModule,
    AppRouterModule,
    RouterModule.forRoot(AppRoutes, {
      useHash: false,
      relativeLinkResolution: 'legacy',
      initialNavigation: 'enabledBlocking',
    }),
    AgmCoreModule.forRoot({
      apiKey: environment.google.maps.key,
    }),
    Angulartics2Module.forRoot({
      pageTracking: {
        basePath: '/',
        clearHash: false,
      },
    }),
    CoreModule,
    SharedModule,
  ],

  declarations: [ErrorPageRouterComponent, AppRouterComponent],

  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [AppInitializerService],
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useFactory: (translate: TranslateService) => translate.getLocaleId(),
      deps: [TranslateService],
    },
    {
      provide: HTTP_MODULE_CONFIG,
      useValue: { serviceUrl: environment.serviceUrl },
    },
  ],
  bootstrap: [AppRouterComponent],
})
export class AppModule {}
